import getRecommendedDomainMapPlansSelect from '../get-recommended-domain-map'

function getRecommendedByIdPlanSelector (id) {
  return (state) => getRecommendedDomainMapPlansSelect(state)[id]
}

export default getRecommendedByIdPlanSelector
